import { render, staticRenderFns } from "./customvueselect.vue?vue&type=template&id=7681b0d6&"
import script from "./customvueselect.vue?vue&type=script&lang=js&"
export * from "./customvueselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports